var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTaskReview = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C14.4184 18 18 14.4184 18 10C18 5.5816 14.4184 2 10 2C5.5816 2 2 5.5816 2 10C2 14.4184 5.5816 18 10 18ZM7.71429 6C8.02988 6 8.28571 6.25584 8.28571 6.57143V13.4286C8.28571 13.7442 8.02988 14 7.71429 14C7.39869 14 7.14286 13.7442 7.14286 13.4286V6.57143C7.14286 6.25584 7.39869 6 7.71429 6ZM12.8571 6.57157C12.8571 6.25598 12.6013 6.00014 12.2857 6.00014C11.9701 6.00014 11.7143 6.25598 11.7143 6.57157V13.4287C11.7143 13.7443 11.9701 14.0001 12.2857 14.0001C12.6013 14.0001 12.8571 13.7443 12.8571 13.4287V6.57157Z",
    fill: "#736EEF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTaskReview);
export default ForwardRef;